import styled, { css } from 'styled-components'

export const Button = styled.input`
  outline-color: #002d63;
  width: 100%;
  ${({ height }) => height ? css`height: ${height}` : css`height: 48px`};
  border: 1px solid #c7c9c7;
  box-sizing: border-box;
  border-radius: 4px;
  color: #ffffff;
  background-color: ${({ disabled }) => (disabled ? '#bbbbbb' : ' #25a37b')};
  flex: 1;
`
